import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const HistoryContext = createContext([]);

export const HistoryProvider = ({ children }) => {
  const location = useLocation();
  const [currentScreen, setCurrentScreen] = useState(null);
  const [customPath, setCustomPath] = useState(null);

  useEffect(() => {
    // Update current screen whenever location changes
    if (location.pathname !== '/dashboard') {
      setCurrentScreen(location.pathname);
      removeCustomPath()
    }
  }, [location]);

  // Get breadcrumb list: always Dashboard first, then current screen, then custom path
  const getBreadcrumbList = () => {
    const list = ['/dashboard'];

    if (currentScreen && currentScreen !== '/dashboard') {
      list.push(currentScreen);
    }

    if (customPath) {
      list.push(customPath);
    }

    return list;
  };

  // Add a custom display-only path
  const addCustomPath = (name) => {
    setCustomPath({ path: name, isCustom: true });
  };

  // Remove the custom path
  const removeCustomPath = () => {
    setCustomPath(null);
  };

  // Clear current screen (navigate back to dashboard)
  const clearCurrentScreen = () => {
    setCurrentScreen(null);
  };

  return (
    <HistoryContext.Provider value={{
      breadcrumbList: getBreadcrumbList(),
      currentScreen,
      customPath,
      addCustomPath,
      removeCustomPath,
      clearCurrentScreen
    }}>
      {children}
    </HistoryContext.Provider>
  );
};

// Hook to access breadcrumb context
export const useHistoryList = () => useContext(HistoryContext);